import { restClient } from '../config/restClient'

const endpoint = companyProfileId => `/api/company/v2/company_profiles/${companyProfileId}`

export const getCompanyAccount = async companyProfileId => {
  const response = await restClient(endpoint(companyProfileId), {
    method: 'GET',
  })
  return response.data
}
